import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { VideoPlayerEventTracking } from '@/modules/core/app/models/segmentevents/VideoPlayerEventTracking';

export class VideoPlayerStartedSegmentEvent extends VideoPlayerEventTracking {
  static eventName: string = SegmentEvent.VIDEO_PLAYER_SEGMENT_WATCHED;
}
